import { Cell, Grid, Text, VFlow } from 'bold-ui'
import { VulnerabilidadeFamiliar } from 'graphql/types.generated'

import { CriteriosVulnerabilidadeFamiliarAccordion } from './CriteriosVulnerabilidadeFamiliarAccordion'
import { VulnerabilidadeFamiliarResult } from './VulnerabilidadeFamiliarResult'

interface VulnerabilidadeFamiliarProntuarioPanelProps {
  vulnerabilidadeFamiliar: VulnerabilidadeFamiliar
}

export const VulnerabilidadeFamiliarProntuarioPanel = ({
  vulnerabilidadeFamiliar,
}: Readonly<VulnerabilidadeFamiliarProntuarioPanelProps>) => {
  const { classificacao, grauSugestivo, escore, classificacaoSubestimada, criterios } = vulnerabilidadeFamiliar

  const { criteriosInequivocos, criteriosSugestivos } = criterios || {}
  const hasCriterios = criteriosInequivocos.length > 0 || criteriosSugestivos.length > 0

  return (
    <Grid wrap gapVertical={1}>
      <Cell size={12}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Vulnerabilidade familiar</Text>
          <VulnerabilidadeFamiliarResult
            classificacao={classificacao}
            escore={escore}
            grauSugestivo={grauSugestivo}
            classificacaoSubestimada={classificacaoSubestimada}
          />
        </VFlow>
      </Cell>

      {hasCriterios && (
        <Cell size={12}>
          <CriteriosVulnerabilidadeFamiliarAccordion criterios={criterios} />
        </Cell>
      )}
    </Grid>
  )
}
